PJQ.views.commitments.CommitmentDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'No Commitments have been created yet',
            zeroRecords: "No Commitments matched the search criteria"
        },
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.COMMITMENTS, 'data-table-header-commitments')
        },
        toggleRowClass: '.commitment-toggle-row'
    },
    events: {
        'click .view-commitment': 'viewCommitmentClicked',
    },
    beforeDataTableRender: function () {
        this.options.pageLength = this.options.settings ? this.options.settings.rowsPerPage : 10;
    },
    getDefaultFilter: function () {
        let defaultFilter = {};
        defaultFilter[PJQ.constants.commitments.filterType.TYPE_FILTER] = this.options.userSettings.get('defaultCommitmentTypeFilter');
        defaultFilter[PJQ.constants.commitments.filterType.TYPE_FILTER] = _.map(defaultFilter[PJQ.constants.commitments.filterType.TYPE_FILTER], function (type) {
            return type * -1;
        });
        defaultFilter[PJQ.constants.commitments.filterType.STATUS_FILTER] = _.size(this.options.statusIds) > 0 ? this.options.statusIds : this.options.userSettings.get('defaultCommitmentStatusFilter');
        return defaultFilter;
    },
    afterSearch: function () {
        if (typeof this.options.afterSearch === 'function') {
            this.options.afterSearch();
        }
    },
    afterHeaderRender: function () {
        new PJQ.inputs.Selectpicker({
            el: this.$('.commitments-filter'),
            defaultValue: this.getDefaultFilter(),
            isGrouped: true,
            isIntChoices: true,
            isMultiple: true,
            noneSelectedText: 'No Filters',
            onChange: _.bind(function (value) {
                _.each(value, _.bind(function (value, filter) {
                    if (filter === PJQ.constants.commitments.filterType.TYPE_FILTER) {
                        value = _.map(value, function (type) {
                            return type * -1;
                        });
                    }
                    this.setFilter(filter, value);
                }, this));
            }, this)
        });
        _.each(this.getDefaultFilter(), function (value, filter) {
            if (filter === PJQ.constants.commitments.filterType.TYPE_FILTER) {
                value = _.map(value, function (type) {
                    return type * -1;
                });
            }
            this.setFilter(filter, value);
        }, this)
    },
    getFilterData: function () {
        let typeFilter = this.getFilter(PJQ.constants.commitments.filterType.TYPE_FILTER),
            statusFilter = this.getFilter(PJQ.constants.commitments.filterType.STATUS_FILTER);
        if (_.size(typeFilter) === 0 && _.size(statusFilter) === 0) {
            return this.options.data;
        }

        return _.filter(this.options.data, function (row) {
            return (_.size(typeFilter) === 0 || _.contains(typeFilter, row.get('commitmentType'))) && (_.size(statusFilter) === 0 || _.contains(statusFilter, row.get('statusId')));
        });
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['createdOn', 'commitmentType', 'number', 'title', 'description', 'commitmentStatus', 'deliveryDate', 'startDate', 'estimatedCompletionDate', 'actualCompletionDate', 'contractDate', 'signedContractReceivedDate', 'executionDate', 'issuedOnDate', 'returnedDate', 'letterOfIntentDate', 'approvalLetterDate', 'paymentTerms', 'shipVia', 'inclusions', 'exclusions', 'contractedContact.companyName', 'status', 'amount', 'markupAmount', 'taxAmount', 'defaultWorkRetainage', 'defaultMaterialRetainage', 'currentRetainage', 'grandTotal', 'approvedChanges', 'contractTotal', 'progressAmount', 'amountRemaining'];
        if (this.options.customFields) {
            _.each(this.options.customFields.models, _.bind(function (customField) {
                includeColumns.push('fieldValue' + customField.get('fieldNumber'));
            }, this));
        }

        if (!includeAllColumns) {
            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings.columnsDefault;

            columns.push({
                "columnData": "erpObject",
                "data": null,
                "title": "",
                "width": "20px",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": (data, type, row) => {
                    if (!this.options.isAdmin) {
                        return "";
                    }

                    let exObj = row.get('externalObject');
                    if (exObj == null) {
                        return '';
                    }

                    return PJQ.helpers.erp.getERPBadge(exObj.status, exObj);
                }
            });
        }

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'status':
                    columns.push({
                        "columnData": "status",
                        "data": "attributes.statusId",
                        "title": "Status",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.constants.commitments.commitmentStatusNames[row.get('statusId')]
                        }, this)
                    });
                    break;
                case 'commitmentType':
                    columns.push({
                        "columnData": "commitmentType",
                        "data": "attributes.commitmentType",
                        "title": "Type",
                        "width": "110px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.constants.commitments.commitmentTypeNames[row.get('commitmentType')]
                        }, this)
                    });
                    break;
                case 'number':
                    columns.push({
                        "columnData": "number",
                        "data": "attributes.number",
                        "title": "Number",
                        "render": _.bind(function (data, type, row) {
                            if (type === 'sort' || type === 'type') {
                                return row.get('number');
                            }

                            return '<a class="btn-view-commitment" href="javascript:void(0)" data-id="' + row.get('number') + '">' + row.get('number') + '</a>';
                        }, this)
                    });
                    break;
                case 'title':
                    columns.push({
                        "columnData": "title",
                        "data": "attributes.title",
                        "title": "Title"
                    });
                    break;
                case 'description':
                    columns.push({
                        "columnData": "description",
                        "data": "attributes.description",
                        "title": "Description"
                    });
                    break;
                case 'createdOn':
                    columns.push({
                        "columnData": "createdOn",
                        "data": "attributes.createdOn",
                        "title": 'Created',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }, this)
                    });
                    break;
                case 'deliveryDate':
                    columns.push({
                        "columnData": "deliveryDate",
                        "data": "attributes.deliveryDate",
                        "title": 'Delivery',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'startDate':
                    columns.push({
                        "columnData": "startDate",
                        "data": "attributes.startDate",
                        "title": 'Start',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'estimatedCompletionDate':
                    columns.push({
                        "columnData": "estimatedCompletionDate",
                        "data": "attributes.estimatedCompletionDate",
                        "title": 'Est. Complete',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'actualCompletionDate':
                    columns.push({
                        "columnData": "actualCompletionDate",
                        "data": "attributes.actualCompletionDate",
                        "title": 'Act. Complete',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'contractDate':
                    columns.push({
                        "columnData": "contractDate",
                        "data": "attributes.contractDate",
                        "title": 'Contract Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'signedContractReceivedDate':
                    columns.push({
                        "columnData": "signedContractReceivedDate",
                        "data": "attributes.signedContractReceivedDate",
                        "title": 'Signed Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'executionDate':
                    columns.push({
                        "columnData": "executionDate",
                        "data": "attributes.executionDate",
                        "title": 'Execution Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'issuedOnDate':
                    columns.push({
                        "columnData": "issuedOnDate",
                        "data": "attributes.issuedOnDate",
                        "title": 'Issued On',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'returnedDate':
                    columns.push({
                        "columnData": "returnedDate",
                        "data": "attributes.returnedDate",
                        "title": 'Returned On',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'letterOfIntentDate':
                    columns.push({
                        "columnData": "letterOfIntentDate",
                        "data": "attributes.letterOfIntentDate",
                        "title": 'Letter of Intent',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'approvalLetterDate':
                    columns.push({
                        "columnData": "approvalLetterDate",
                        "data": "attributes.approvalLetterDate",
                        "title": 'Approval Letter',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'paymentTerms':
                    columns.push({
                        "columnData": "paymentTerms",
                        "data": "attributes.paymentTerms",
                        "title": "Payment Terms"
                    });
                    break;
                case 'shipVia':
                    columns.push({
                        "columnData": "shipVia",
                        "data": "attributes.shipVia",
                        "title": "Shipping Info"
                    });
                    break;
                case 'inclusions':
                    columns.push({
                        "columnData": "inclusions",
                        "data": "attributes.inclusions",
                        "title": "Inclusions"
                    });
                    break;
                case 'exclusions':
                    columns.push({
                        "columnData": "exclusions",
                        "data": "attributes.exclusions",
                        "title": "Exclusions"
                    });
                    break;
                case 'contractedContact.companyName':
                    columns.push({
                        "columnData": "contractedContact.companyName",
                        "title": "Company",
                        "titleSettings": "Contracted Company",
                        "render": _.bind(function (data, type, row) {
                            return row.get('contractedContact') ? row.get('contractedContact').companyName : 'N/A';
                        }, this)
                    });
                    break;
                case 'amount':
                    columns.push({
                        "columnData": "amount",
                        "data": "attributes.amount",
                        "width": "150px",
                        "title": "Amount",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                        }, this)
                    });
                    break;
                case 'taxAmount':
                    columns.push({
                        "columnData": "taxAmount",
                        "data": "attributes.taxAmount",
                        "title": "Tax",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(data);
                        }, this)
                    });
                    break;
                case 'markupAmount':
                    columns.push({
                        "columnData": "markupAmount",
                        "data": "attributes.markupAmount",
                        "title": "Markup",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(data);
                        }, this)
                    });
                    break;
                case 'defaultWorkRetainage':
                    columns.push({
                        "columnData": "defaultWorkRetainagePercent",
                        "data": "attributes.defaultWorkRetainagePercent",
                        "width": "150px",
                        "title": "Default Work Retainage",
                        "className": "text-align-right",
                        "render": (data, type, row) => {
                            return PJQ.helpers.formatHelpers.formatPercent(row.get('defaultWorkRetainagePercent') ?? 0);
                        }
                    });
                    break;
                case 'defaultMaterialRetainage':
                    columns.push({
                        "columnData": "defaultMaterialRetainagePercent",
                        "data": "attributes.defaultMaterialRetainagePercent",
                        "width": "150px",
                        "title": "Default Material Retainage",
                        "className": "text-align-right",
                        "render": (data, type, row) => {
                            return PJQ.helpers.formatHelpers.formatPercent(row.get('defaultMaterialRetainagePercent') ?? 0);
                        }
                    });
                    break;
                case 'currentRetainage':
                    columns.push({
                        "columnData": "currentRetainage",
                        "data": "attributes.retainageAmount",
                        "width": "150px",
                        "title": "Current Retainage",
                        "className": "text-align-right",
                        "render": (data, type, row) => {
                            let retainage = (row.get('retainageAmount') ?? 0) - (row.get('retainageReleasedAmount') ?? 0);
                            if (type === 'sort' || type === 'type') {
                                return retainage;
                            }
                            return PJQ.helpers.formatHelpers.formatCurrency(retainage);
                        }
                    });
                    break;
                case 'grandTotal':
                    columns.push({
                        "columnData": "grandTotal",
                        "data": "attributes.amount",
                        "title": "Grand Total",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                        }, this)
                    });
                    break;
                case 'approvedChanges':
                    columns.push({
                        "columnData": "approvedChanges",
                        "data": "attributes.approvedChanges",
                        "width": "150px",
                        "title": "Approved Changes",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('approvedChanges'));
                        }, this)
                    });
                    break;
                case 'contractTotal':
                    columns.push({
                        "columnData": "contractTotal",
                        "data": "attributes.amount",
                        "width": "150px",
                        "title": "Contract Total",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount') + row.get('approvedChanges'));
                        }, this)
                    });
                    break;
                case 'progressAmount':
                    columns.push({
                        "columnData": "progressAmount",
                        "data": "attributes.progressAmount",
                        "width": "150px",
                        "title": "Billed to Date",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('progressAmount'));
                        }, this)
                    });
                    break;
                case 'amountRemaining':
                    columns.push({
                        "columnData": "amountRemaining",
                        "data": "attributes.amountRemaining",
                        "width": "150px",
                        "title": "Amount Remaining",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount') + row.get('approvedChanges') - row.get('progressAmount'));
                        }, this)
                    });
                    break;
                default:
                    if (columnName.startsWith('fieldValue')) {
                        _.each(this.options.customFields.models, function (customField) {
                            if (columnName === 'fieldValue' + customField.get('fieldNumber')) {
                                columns.push({
                                    "columnData": 'fieldValue' + customField.get('fieldNumber'),
                                    "title": customField.get('name'),
                                    "className": [PJQ.constants.commitments.customFieldType.INTEGER, PJQ.constants.commitments.customFieldType.MONEY, PJQ.constants.commitments.customFieldType.PERCENT].indexOf(customField.get('fieldTypeId')) !== -1 ? "text-align-right" : "",
                                    "render": function (data, type, row) {
                                        let fieldValue = row.getCustomFieldValue(customField.get('id'));
                                        fieldValue = (fieldValue !== null) ? fieldValue : '';
                                        switch (customField.get('fieldTypeId')) {
                                            case PJQ.constants.commitments.customFieldType.BOOLEAN:
                                                if (fieldValue != null)
                                                    fieldValue = fieldValue ? 'Yes' : 'No';
                                                break;
                                            case PJQ.constants.commitments.customFieldType.CHOICE:
                                                let choices = [];
                                                // convert single choice value into array so that the logic below can work for both types.
                                                if (typeof fieldValue === 'number')
                                                    fieldValue = [fieldValue];

                                                _.each(customField.choices.models, _.bind(function (choice) {
                                                    if (_.find(fieldValue, function (value) {
                                                        return value === choice.get('id');
                                                    }))
                                                        choices.push(choice.get('name'));
                                                }, this));

                                                fieldValue = choices.join((', '));
                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATE:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATETIME:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.INTEGER:
                                                if (type !== 'sort' && type !== 'type' && fieldValue) {
                                                    fieldValue = parseInt(fieldValue).toLocaleString();
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.MONEY:
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)));
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.PERCENT:
                                                if (type === 'sort' || type === 'type') {
                                                    if (!fieldValue)
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = fieldValue ? PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)), 2, false) + '%' : '';
                                                }
                                                break;
                                        }

                                        return fieldValue;
                                    }
                                });
                            }
                        });
                    }
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "title": '',
                "render": _.bind(function (data, type, row) {
                    return '<div class="show-on-row-hover"><button type="button" class="btn btn-info btn-view-commitment ml-1" title="View commitment"><i class="fal fa-arrow-alt-from-left"></i></button></div>';
                }, this),
                "orderable": false,
                "searchable": false,
                "width": "90px",
                "className": "text-center",
                "visible": true
            });
        }

        return columns;
    },
    getRowChildTable: function (childOpts) {
        childOpts.costTypes = this.options.costTypes;
        childOpts.unitsOfMeasure = this.options.unitsOfMeasure;
        childOpts.groups = this.options.groups;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        return new PJQ.views.commitments.LineItemDataTable(childOpts);
    },
    getRowChildData: function (row) {
        return new PJQ.collections.commitments.CommitmentLineItems(null, {
            commitmentId: row.data().id
        });
    }
});

PJQ.views.commitments.LineItemDataTable = PJQ.views.commitments.BaseDataTable.extend({
    defaults: {
        language: {
            zeroRecords: "No Line Items Added"
        },
        canEdit: false,
        onEditLineItem: _.noop,
        onDeleteLineItem: _.noop
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns;
        if (this.options.parentData && this.options.parentData.get('accountingMethod') === PJQ.constants.budget.accountingMethod.AMOUNT)
            includeColumns = ['group', 'costTypeDescription', 'description', 'amount', 'billedToDate', 'amountRemaining'];
        else
            includeColumns = ['group', 'costTypeDescription', 'description', 'quantity', 'unitOfMeasure', 'unitPrice', 'amount', 'billedToDate', 'amountRemaining'];

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'description':
                    columns.push({
                        "columnData": "description",
                        "data": "attributes.description",
                        "title": "Description"

                    });
                    break;
                case 'quantity':
                    columns.push({
                        "columnData": "quantity",
                        "data": "attributes.quantity",
                        "width": "8%",
                        "title": "Units",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatDecimal(row.get('quantity'), 2);
                        }, this)
                    });
                    break;
                case 'unitOfMeasure':
                    columns.push({
                        "columnData": "unitOfMeasure",
                        "data": "attributes.unitId",
                        "orderable": (!this.options.canEdit),
                        "title": "Unit",
                        "width": "5%",
                        "render": _.bind(function (data, type, row) {
                            let unitOfMeasure = this.options.unitsOfMeasure.get(row.get('unitId'));
                            return unitOfMeasure ? unitOfMeasure.get('code') : '';
                        }, this)
                    });
                    break;
                case 'unitPrice':
                    columns.push({
                        "columnData": "unitPrice",
                        "data": "attributes.unitPrice",
                        "width": "10%",
                        "title": "Unit Price",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('unitPrice'));
                        }, this)
                    });
                    break;
                case 'amount':
                    columns.push({
                        "columnData": "amount",
                        "data": "attributes.amount",
                        "width": "10%",
                        "title": "Amount",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                        }, this)
                    });
                    break;
                case 'billedToDate':
                    columns.push({
                        "columnData": "billedToDate",
                        "data": "attributes.billedToDate",
                        "width": "10%",
                        "title": "Billed",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('billedToDate'));
                        }, this)
                    });
                    break;
                case 'amountRemaining':
                    columns.push({
                        "columnData": "amountRemaining",
                        "data": "attributes.amountRemaining",
                        "width": "10%",
                        "title": "Amount Remaining",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount') - row.get('billedToDate'));
                        }, this)
                    });
                    break;
                case 'group':
                    columns.push({
                        "columnData": "group",
                        "title": "Cost Code",
                        "render": _.bind(function (data, type, row) {
                            let group = this.options.groups.get(row.get('groupId'));
                            return group ? group.get('groupName') : '';
                        }, this)
                    });
                    break;
                case 'costType':
                    columns.push({
                        "columnData": "costType",
                        "title": "Type Code",
                        "titleSettings": "Cost Type",
                        "width": "8%",
                        "render": _.bind(function (data, type, row) {
                            let costType = this.options.costTypes.get(row.get('costTypeId'));
                            return costType ? costType.get('code') : '';
                        }, this)
                    });
                    break;
                case 'costTypeDescription':
                    columns.push({
                        "columnData": "costTypeDescription",
                        "title": "Type",
                        "render": _.bind(function (data, type, row) {
                            let costType = this.options.costTypes.get(row.get('costTypeId'));
                            return costType ? costType.get('name') : '';
                        }, this)
                    });
                    break;
            }
        }, this));

        if (!includeAllColumns && this.options.canEdit) {
            columns.push({
                "title": '',
                "render": _.bind(function (data, type, row) {

                    let html = '<div class="show-on-row-hover">';
                    html += '<button type="button" class="btn btn-info edit-line-item ml-1" title="View Line Item"><i class="fal fa-arrow-alt-from-left"></i></button>';

                    if (PJQ.app.session.project.hasPermission('commitments.canEdit'))
                        html += '<button type="button" class="btn btn-danger delete-line-item ml-1" title="Delete Line Item"><i class="fal fa-trash"></i></button>';

                    html += '</div>';

                    return html;
                }, this),
                "orderable": false,
                "searchable": false,
                "width": "90px",
                "className": "text-center",
                "visible": true
            });
        }

        return columns;
    }
});
